import React from 'react';
import ToggleThemeBtn from './shared/ToggleThemeBtn';

const Header = () => {
  const login = () => {
    if (typeof window !== 'undefined') {
      const redirectUrl = 'https://docs.silabs.com/api/v2/login-redirect';
      const clientId =
        '3MVG9yZ.WNe6byQBECTQsIW3LXKhYn_soJgXLIpSZnXDh6T60o8stVMVX0CW2faTFXJhe8sG4WWqW.KSVaxBD';
      const provider = 'https://community.silabs.com';
      window.location.href = `${provider}/services/oauth2/authorize?client_id=${clientId}&redirect_uri=${redirectUrl}&response_type=code`;
    }
  };
  const readStorageValue = (value: string) => {
    if (typeof window !== 'undefined') {
      const data = window.sessionStorage.getItem('silabsprofile');
      let storageValue = '';
      if (data) {
        const values = data.split('|');
        let i = 0;
        for (; i < values.length; i++) {
          // eslint-disable-next-line @typescript-eslint/prefer-includes
          if (values[i].indexOf(value) > -1) {
            storageValue = values[i].split('=')[1];
            break;
          }
        }
      }
      return storageValue;
    }
    return '';
  };
  const logout = () => {
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem('silabsprofile');
      window.location.href =
        'https://community.silabs.com/apex/SL_Logout?LOF=Docs';
    }
  };
  const clientProfile = readStorageValue('FirstName');

  const accountHome = () => {
    window.location.href = 'https://community.silabs.com/s';
  };

  return (
    <div id="page-header" className="header">
      <div className="header_left">
        <div className="header_logo">
          <a href="https://docs.silabs.com">
            <img
              className="header_img"
              src="/assets/images/logo.svg"
              alt="Silabs Logo"
            />
          </a>
        </div>
        <div className="header_title">
          <div>Developer Documentation</div>
        </div>
      </div>
      <div className="header_tabs">
        <ul className="tab_list">
          <li className="tab_items">
            <a className="header_tab" href="/" target="_blank">
              Home
            </a>
          </li>
          <li className="tab_items">
            <a
              className="header_tab"
              href="https://www.silabs.com/support/training"
              target="_blank"
              rel="noreferrer"
            >
              Training
            </a>
          </li>
          <li className="tab_items">
            <a
              className="header_tab"
              href="https://community.silabs.com/"
              target="_blank"
              rel="noreferrer"
            >
              Community
            </a>
          </li>
          <li className="tab_items">
            <a
              className="header_tab"
              href="https://www.silabs.com/support"
              target="_blank"
              rel="noreferrer"
            >
              Support
            </a>
          </li>
          <li className="tab_items github_tab">
            <a
              className="header_tab"
              href="https://github.com/SiliconLabs"
              target="_blank"
              rel="noreferrer"
            >
              Github
            </a>
          </li>
        </ul>
      </div>
      <div className="header_right">
        <ul className="tab_list">
          <li className="tab_items">
            <ToggleThemeBtn />
          </li>
          <li className="tab_items tab_items_user">
            <button>
              <img src="/assets/images/icons/user.svg" alt="Silabs Login" />
            </button>
            {!clientProfile && (
              <ul className="nav__submenu">
                <li>
                  <a
                    href="#page-header"
                    className="nav__submenu-item"
                    onClick={login}
                  >
                    Login
                  </a>
                </li>
                <li>
                  <a
                    className="nav__submenu-item"
                    href="https://community.silabs.com/SL_CommunitiesSelfReg"
                  >
                    Register
                  </a>
                </li>
              </ul>
            )}
            {clientProfile && (
              <ul className="nav__submenu">
                <li>
                  <span className="nav__submenu-item">
                    Welcome&#44;&#32;{clientProfile}
                  </span>
                </li>
                <li>
                  <span
                    role="button"
                    className="nav__submenu-item link"
                    tabIndex={0}
                    onClick={accountHome}
                    onKeyDown={(e) => e.key === 'Enter' && accountHome()}
                  >
                    Account Home
                  </span>
                </li>
                <li>
                  <a
                    href="#page-header"
                    className="nav__submenu-item"
                    onClick={logout}
                  >
                    Logout
                  </a>
                </li>
              </ul>
            )}
          </li>
          <li className="tab_items kapa-open" data-test-id="header-search">
            <img
              src="/assets/images/icons/icon-ionic-ios-search.svg"
              alt="Silabs Search"
            />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Header;
